<template>
  <div class="escalation-factor-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            @click.prevent="exportCsv()"
            class="btn-color ml-4"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/2">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/2 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.escalation_factor')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{
              $t("labels.escalation_factor")
            }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddEscalationfactor' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('escalation-factors', 'add')"
              >{{ $t("labels.add_escalation_factor") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="escalation_factor" class="permission">
        <template slot="thead">
          <vs-th class="col-md-5">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-5">{{
            $t("labels.escalation_factor_barrier")
          }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">{{ tr.name }}</vs-td>
            <vs-td>{{
              escalation_barrier(tr.escalation_factor_barriers)
            }}</vs-td>
            <vs-td width="130">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({
                      name: 'EditEscalationfactor',
                      params: { id: tr.id },
                    })
                  "
                  v-if="checkPermission('escalation-factors', 'modify')"
                ></vs-button>

                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-show="checkPermission('escalation-factors', 'delete')"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      escalation_factor: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      search: null,
    };
  },
  computed: {},
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getEscalationFactors();
    },
    currentx(val) {
      this.getEscalationFactors();
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getEscalationFactors();
  },
  methods: {
    escalation_barrier(barriers) {
      let m = [];
      if (barriers.length > 0) {
        barriers.forEach((element) => {
          m.push(element.name);
        });
        m = m.join(", ");
        return m;
      } else {
        return "";
      }
    },
    async getEscalationFactors(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse(
        "/escalation-factors/list",
        input
      );
      if (exp) {
        this.exportFile(response, "EscalationFactors");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let escalation_factor = data.escalation_factors;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.escalation_factor = escalation_factor;
        }
      }
    },
    exportCsv() {
      this.getEscalationFactors(true);
    },
    filter() {
      this.getEscalationFactors();
    },
    clearFilter() {
      this.search = null;
      this.getEscalationFactors();
    },
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteEscalationFactor,
      });
    },
    async deleteEscalationFactor() {
      if (this.index < 0) return;
      let url = "escalation-factors/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.escalation_factor[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getEscalationFactors();
      }
    },
  },
};
</script>
<style scoped>
p {
  font-weight: 600;
}
</style>
